export interface InterestRate {
    "Modified Date": number
    "Created Date": number
    "Created By": string
    "type": string
    "Value": number
    "Duration": number
    delay: number
    "partner": string
    "_id": string
}

export const DEFAULT_INTEREST_RATE:InterestRate  = {
    "Modified Date": 0,
    "Created Date": 0,
    "Created By": '',
    "type": '',
    "Value": 0,
    "Duration": 0,
    delay: 0,
    "partner": '',
    "_id": '',
}

export interface ServiceRate {
    "Modified Date": number
    "Created Date": number
    "Created By": string
    "Name": string
    "Value": number
    "Description": string
    "_id": string
}

export const DEFAULT_SERVICE_RATE:ServiceRate  = {
    "Modified Date": 0,
    "Created Date": 0,
    "Created By": '',
    "Name": '',
    "Value": 0,
    "Description": '',
    "_id": '',
}

export interface Rate {
    interest_rate: InterestRate[]
    service_rate: ServiceRate
}

export interface UpgradLoanOverview {
    //Amount
    baseAmount: number
    prepayAmount: number
    prepayAdditionalAmount: number
    loanAmount: number

    //Rate
    prepayRate: number //rate for prepay
    loanRate: number //rate per year
    serviceRate: number // rate for service

    //Duration
    duration: number //duration pay rate and base
    rateOnlyDuration: number //duration only pay rate
}

export interface UpgradLoanPerMonth {
    currentMonth: number
    downDebtRemainAmount: number //Dư nợ còn lại
    downRateAmount: number //Lãi phải trả
    downBaseAmount: number //Gốc phải trả
    paymentAmount: number //Số tiền hàng tháng trả
}

export interface UpgradLoanSchedule {
    loanSchedule: UpgradLoanPerMonth[]
    sumDebtRemainAmount: number //Tổng dư nợ còn lại
    sumRateAmount: number //Tổng lãi phải trả
    sumBaseAmount: number // Tổng gốc phải trả
    sumPaymentAmount: number // Tổng Trả hàng tháng
    paymentPerMonthAmount: number //Trả mỗi tháng
    paymentPerMonthWithoutInterest: number //Trả mỗi tháng miễn gốc
}

export const UPGRAD_LOAN_OVERVIEW: UpgradLoanOverview = {
    baseAmount: 0,
    prepayAmount: 0,
    prepayAdditionalAmount: 0,
    loanAmount: 0,
    prepayRate: 0,
    loanRate: 0,
    serviceRate: 0,
    duration: 0,
    rateOnlyDuration: 0
}

export const UPGRAD_LOAN_PER_MONTH:UpgradLoanPerMonth = {
    currentMonth: 0,
    downDebtRemainAmount: 0,
    downRateAmount: 0,
    downBaseAmount: 0,
    paymentAmount: 0,
}

export const UPGRAD_LOAN_SCHEDULE: UpgradLoanSchedule = {
    loanSchedule: [UPGRAD_LOAN_PER_MONTH],
    sumDebtRemainAmount: 0,
    sumRateAmount: 0,
    sumBaseAmount: 0,
    sumPaymentAmount: 0,
    paymentPerMonthAmount: 0,
    paymentPerMonthWithoutInterest: 0
}